// extracted by mini-css-extract-plugin
export default {"container":"style_container__IF05s","title":"style_title__2yd0z","divider":"style_divider__e2Ogg","children":"style_children__bXumy","formFooter":"style_formFooter__lFaZp"};